import React, { useState, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { toast } from '../../utils/customToast';
import Modal from '../shared/Modal';

const JoinTenantModal = ({ onClose, onSuccess }) => {
    const [inviteCode, setInviteCode] = useState('');
    const [loading, setLoading] = useState(false);
    const { getAuthHeaders } = useAuth();

    const nameInputRef = useRef(null);
    const cancelRef = useRef(null);
    const confirmRef = useRef(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/tenants/join/${inviteCode}`, {
                method: 'POST',
                headers: getAuthHeaders()
            });

            if (response.ok) {
                toast.success('Vous avez rejoint l\'organisation!');
                onSuccess();
            } else {
                const data = await response.json();
                toast.error(data.message || 'Code invalide ou expiré');
            }
        } catch (error) {
            console.error('Error joining tenant:', error);
            toast.error('Erreur réseau');
        } finally {
            setLoading(false);
        }
    };

    // Modal actions
    const modalActions = (
        <>
            <button
                ref={cancelRef}
                type="button"
                onClick={onClose}
                disabled={loading}
                className="flex-1 bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-200 font-bold py-2 px-4 rounded hover:bg-gray-400 dark:hover:bg-gray-600"
            >
                Annuler
            </button>
            <button
                ref={confirmRef}
                type="submit"
                form="join-tenant-form"
                disabled={loading || inviteCode.length < 10}
                className="flex-1 bg-primary text-white dark:text-black font-bold py-2 px-4 rounded hover:bg-primary-hover disabled:bg-gray-400 dark:disabled:bg-gray-600"
            >
                {loading ? 'Vérification...' : 'Rejoindre'}
            </button>
        </>
    );

    return (
        <>
            <Modal
                open={true}
                onClose={onClose}
                title="Rejoindre une organisation"
                actions={modalActions}
                initialFocusRef={nameInputRef}
            >
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                    Entrez le code d'invitation fourni par l'administrateur de l'organisation.
                </p>

                <form id='join-tenant-form' onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Code d'invitation
                        </label>
                        <input
                            ref={nameInputRef}
                            type="text"
                            value={inviteCode}
                            onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
                            className="w-full p-3 border dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:ring-2 focus:ring-primary focus:border-primary font-mono text-center text-lg tracking-wider"
                            required
                            disabled={loading}
                            placeholder="XXXX-XXXX-XXXX"
                            maxLength={14}
                        />
                    </div>
                </form>
            </Modal>
        </>
    );
};

export default JoinTenantModal;
